import styled from "styled-components";

export const DownloadButton = styled.button`
  position: absolute;
  bottom: 15%;
  left: 5%;
  font-size: 16px;
  width: auto;
  height: 40px;
  background: transparent;
  border: 2px solid #279be9;
  border-radius: 20px;
  z-index: 10;
`;
export const StyledLink = styled.a`
  display: flex;
  padding: 5px;
  text-decoration: none;
  color: #279be9;
  :hover {
    color: #279be9;
  }
`;
